export const UserAccessRightsFiltersCookiesData = [
    'usersAccessRightsDivision',
    'usersAccessRightsBrands',
    'usersAccessRightsCountries'
]
